













import { Vue, Component, Inject, Prop } from "vue-property-decorator";

// Types
import {
  ICProdProvProvider,
  ICProdProvProviderMethods
} from "@/models/providers/contractProduct";

@Component({
  components: {
    "cprod-action-control": () =>
      import("@/components/app/global/contractProducts/cProdActionControl.vue")
  }
})
export default class CProdProvActions extends Vue {
  // Inject

  @Inject({ from: "cProdProvProvider" })
  public readonly $cProdProvProvider!: () => ICProdProvProvider;

  @Inject({ from: "cProdProvProviderMethods" })
  public readonly $cProdProvMethods!: ICProdProvProviderMethods;

  // Props

  @Prop({ default: false })
  public readonly highlighted!: boolean;

  // Computed

  public get cProdProvData() {
    return this.$cProdProvProvider();
  }

  public get filteredFunctions() {
    return this.$_.filter(this.cProdProvData.cProdProvFunctions, func =>
      this.highlighted ? func.highlight : true
    );
  }
}
